import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	user: null, // { name, email, profilePic, etc. }
	loading: false,
	error: null,
};

const userAccountSlice = createSlice({
	name: 'userAccount',
	initialState,
	reducers: {
		setUserAccount(state, action) {
			state.user = action.payload;
		},
		updateUserAccountField(state, action) {
			const { key, value } = action.payload;
			if (state.user) {
				state.user[key] = value;
			}
		},
		clearUserAccount(state) {
			state.user = null;
		},
	},
});

export const { setUserAccount, updateUserAccountField, clearUserAccount } = userAccountSlice.actions;

export default userAccountSlice.reducer;
